import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  pageSize = 10;
  pageIndex = 0;
  pageEvent;
  // totalSize = 0;
  @Input('totalSize') totalSize;
  @Output() pageSizeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() pageIndexChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    console.log("totalSize", this.totalSize);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("totalSize", this.totalSize);
  }

  handlePage(e: any) {
    console.log('Hnadle page', e)
    this.pageSize = e.pageSize;
    this.pageSizeChange.emit({ pgSize: this.pageSize })
    this.pageIndex = e.pageIndex;
    this.pageIndexChange.emit({ pgIndex: this.pageIndex })
  }

}
